(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tr-material', {
                parent: 'app',
                url: '/tr-material',
                data: {
                    authorities: ['MATERIAL_SIDEBAR'],                   
                    pageTitle: 'trakeyeApp.material.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-material/tr-materials.html',
                        controller: 'TrMaterialController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null,
                    listgeofenceid: null,
                    rangeOption : {value:'day'},
                    fromTime : null ,
                    toTime : null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            listgeofenceid: $stateParams.listgeofenceid,
                            rangeOption : $stateParams.rangeOption,
                            fromTime : $stateParams.fromTime ,
                            toTime : $stateParams.toTime
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trMaterial');
                        $translatePartialLoader.addPart('materialStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-material-detail', {
                parent: 'tr-material',
                url: '/tr-material/{id}',
                data: {
                    authorities: ['MATERIAL_DETAIL'],
                    pageTitle: 'trakeyeApp.material.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-material/tr-material-detail.html',
                        controller: 'TrMaterialDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trMaterial');
                        $translatePartialLoader.addPart('materialStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TrMaterial', function ($stateParams, TrMaterial) {
                        return TrMaterial.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-material',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('tr-material.priority', {
                parent: 'tr-material',
                url: '/tr-materials/priority/{priority}/{geofenceId}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.material.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-material/tr-materials.html',
                        controller: 'TrMaterialController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            priority: $stateParams.priority,
                            geofenceId : $stateParams.geofenceId
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trMaterial');
                        $translatePartialLoader.addPart('materialStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-material.attendance', {
                parent: 'tr-material',
                url: '/tr-materials/attendance/{login}/{fromTime}/{toTime}/{materialStatus}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD','ROLE_OA', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER','ROLE_PLAN_ADMIN'],
                    pageTitle: 'trakeyeApp.material.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-material/tr-materials.html',
                        controller: 'TrMaterialController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            login: $stateParams.login,
                            fromTime: $stateParams.fromTime,
                            toTime: $stateParams.toTime,
                            materialStatus: $stateParams.materialStatus
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trMaterial');
                        $translatePartialLoader.addPart('materialStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-material.new', {
                parent: 'tr-material',
                url: '/create/{lat}/{lng}/{assetdetails}/{desc}',
                data: {
                    authorities: ['MATERIAL_CREATE']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-material/tr-material-dialog.html',
                        controller: 'TrMaterialDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            description: $stateParams.desc,
                            createDate: null,
                            updateDate: null,
                            pinLat: parseFloat($stateParams.lat),
                            pinLong: parseFloat($stateParams.lng),
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            materialImages: []
                            // ,
                            // asset: {name: $stateParams.assetdetails}
                        };
                    }]
                }
            })

        .state('tr-material.workflow', {
            url: '/work-flow',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tr-material/tr-material-work-flow.html',
                    controller: 'TrMaterialWorkFlowController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                    return {
                        description: $stateParams.desc,
                        createDate: null,
                        updateDate: null,
                        pinLat: parseFloat($stateParams.lat),
                        pinLong: parseFloat($stateParams.lng),
                        address: null,
                        escalated: null,
                        status: null,
                        id: null,
                        materialImages: []
                    };
                }]
            }
        })

        .state('tr-material.import', {
                parent: 'tr-material',
                url: '/import',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-material/tr-material-import.html',
                        controller: 'TrMaterialImportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            materialImages: []
                        };
                    }
                }

            })
            .state('tr-material.edit', {
                parent: 'tr-material',
                url: '/Edit/{id}',
                data: {
                    authorities: ['MATERIAL_EDIT'],
                    pageTitle: 'trakeyeApp.material.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-material/tr-material-dialog.html',
                        controller: 'TrMaterialDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    entity: ['$stateParams', 'TrMaterial', function ($stateParams, TrMaterial) {
                        return TrMaterial.get({ id: $stateParams.id }).$promise;
                    }],


                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-material',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('tr-material.delete', {
                parent: 'tr-material',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tr-material/tr-material-delete-dialog.html',
                        controller: 'TrMaterialDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TrMaterial', function (TrMaterial) {
                                return TrMaterial.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tr-material', null, { reload: 'tr-material' });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tr-material.fibercore', {
                parent: 'tr-material',
                url: '/fibercore',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-material/tr-material-fiber-core.html',
                        controller: 'TrMaterialFiberCoreController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            materialImages: []
                        };
                    }
                }

            })

            .state('show-hide-material', {
                parent: 'report',
                url: '/show-hide-material',
                data: {
                    authorities: ['ROLE_USER_ADMIN'],
                    pageTitle: 'trakeyeApp.report.generic-report'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-material/show-hide-material.html',
                        controller: 'ShowHideMaterialController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reports');
                        $translatePartialLoader.addPart('logSource');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('geofence-material', {
                parent: 'report',
                url: '/geofence-material',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.report.generic-report'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-material/geofence-materialTxn.html',
                        controller: 'geofenceMaterialController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reports');
                        $translatePartialLoader.addPart('logSource');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }
})();